import { toast } from 'react-toastify'
import { apiConstants } from '../apiConstant'
import compileErrors from '../compileErorrs'
import { formDataCommonFunction } from '../serviceCall'
import { setLoading } from '../../feature/authSlice'

export const uploadReverseApi = (data,param, callback, errorCallBack) => {

  return async (dispatch) => {
    dispatch(setLoading(true))
    formDataCommonFunction(data,`${apiConstants.Invoices.UPLOAD_REVERSE_FILE}?IsTelephone=${param}`)
      .then((response) => {
        dispatch(setLoading(false))
        callback && callback(response)
      })
      .catch((error) => {
        dispatch(setLoading(false))
        toast.error(compileErrors(error.response.data.error))
        errorCallBack && errorCallBack(error.response)
      })
  }
}
